import getHexColorFromNamed from './getHexColorFromNamed/getHexColorFromNamed.js'
export * from './colors.js'
export { getHexColorFromNamed }
